__turbopack_context__.v({
  "brLinks": "BRLinks-module-scss-module__LbREma__brLinks",
  "divider": "BRLinks-module-scss-module__LbREma__divider",
  "icon": "BRLinks-module-scss-module__LbREma__icon",
  "impressum": "BRLinks-module-scss-module__LbREma__impressum",
  "link": "BRLinks-module-scss-module__LbREma__link",
  "linkTitle": "BRLinks-module-scss-module__LbREma__linkTitle",
  "section": "BRLinks-module-scss-module__LbREma__section",
});
